<p-dialog
  header="SKU Journey"
  [(visible)]="showSkuDetailsDialog"
  [style]="{ width: '84vw' }"
  [modal]="true"
  styleClass="voting-dialog"
  [draggable]="false"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="content">
    <p-tabView
      styleClass="zone-requests-tabs"
      *ngIf="dataFrom !== 'simulation'"
      (onChange)="onTabChange($event)"
    >
      <p-tabPanel header="Country" *ngIf="clusterLevelDict['Country']">
        <div class="my-3"></div>
      </p-tabPanel>
      <p-tabPanel header="Region" *ngIf="clusterLevelDict['Region']">
        <div class="my-3">
          <app-sku-details-dropdown
            (actionBtnCallback)="onSubLevelChange($event, 'region')"
            [dropdownOptions]="regionClusterList"
          >
          </app-sku-details-dropdown>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Channel" *ngIf="clusterLevelDict['Channel']">
        <div class="my-3">
          <app-sku-details-dropdown
            (actionBtnCallback)="onSubLevelChange($event, 'channel')"
            [dropdownOptions]="channelClusterList"
          >
          </app-sku-details-dropdown>
        </div>
      </p-tabPanel>
      <p-tabPanel header="State" *ngIf="clusterLevelDict['State']">
        <div class="my-3">
          <app-sku-details-dropdown
            (actionBtnCallback)="onSubLevelChange($event, 'state')"
            [dropdownOptions]="stateClusterList"
          >
          </app-sku-details-dropdown>
        </div>
      </p-tabPanel>
    </p-tabView>

    <div class="flex justify-between sku-name-id-levels">
      <div class="sku-name-id">
        <p class="label">
          {{ getValue("sku_detail") }}
          <span class="innovation-chip">{{
            getValue("is_innovation") ? "Innovation" : "Non-Innovation"
          }}</span>
          <span class="obppc_category" [ngClass]="skuDetails?.obppc_category">
            {{ getValue("obppc_category") }}
          </span>
        </p>
        <p class="value">
          ID <span class="sku-id pr-1">{{ getValue("sku") }}</span
          >|<span class="pl-1">{{ getValue("sku_age") }}</span> Months |
          <span class="pl-1">{{
            getValue("brand") | titleFirstLetterCaps
          }}</span>
          |<span class="pl-1">{{
            getValue("ptc_segment") | titleFirstLetterCaps
          }}</span>
          |<span class="pl-1">{{
            getValue("pack_type") | titleFirstLetterCaps
          }}</span>
        </p>
      </div>
      <div class="flex justify-between levels-block">
        <div class="mr-3 pl-2 pr-4 border-r border-gray-200 mt-2">
          <p class="label">Level 1</p>
          <p
            class="value"
            [ngClass]="{
              'keep-recommendation':
                getValue('level1_recommendation') === 'Keep',
              'delist-recommendation':
                getValue('level1_recommendation') === 'Delist',
              'consult-recommendation':
                getValue('level1_recommendation') === 'Consult',
            }"
          >
            {{ getValue("level1_recommendation") }}
          </p>
        </div>
        <div class="px-2 mt-2">
          <p class="label">Level 2</p>
          <p
            class="value"
            [ngClass]="{
              'keep-recommendation': getValue('level2_recommendation')
                ? getValue('level2_recommendation')
                : getValue('model_output') === 'Keep',
              'delist-recommendation': getValue('level2_recommendation')
                ? getValue('level2_recommendation')
                : getValue('model_output') === 'Delist',
              'consult-recommendation': getValue('level2_recommendation')
                ? getValue('level2_recommendation')
                : getValue('model_output') === 'Consult',
            }"
          >
            {{
              getValue("level2_recommendation")
                ? getValue("level2_recommendation")
                : getValue("model_output")
            }}
          </p>
        </div>
        <div class="flex items-center sku-ranking rounded justify-between">
          <div class="my-auto p-1">
            <img src="/assets/images/credit-score.svg" alt="creditScore" />
          </div>
          <div class="my-auto p-2">
            <p class="label pt-1">SKU Ranking Score</p>
            <p class="value sku_rank_value">
              {{ getValue("sku_ranking_score")?.toFixed(0) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-9" [ngClass]="{ 'col-12': dataFrom == 'simulation' }">
        <div class="overflow-y-auto overflow-container">
          <div class="w-full">
            <div
              class="grid grid-cols-5 sku-features-block gap-4 p-3"
              [ngClass]="{ 'grid-cols-8': dataFrom == 'simulation' }"
            >
              <div class="sku-features" *ngFor="let item of skuFeatures">
                <p class="label">
                  {{ item.label }}
                  <span *ngIf="item.unit">{{ item.unit }}</span>
                </p>
                <p class="value">
                  <!-- Checking for MACO Uplift or Volume Retained and conditionally showing "-" -->
                  <ng-container
                    *ngIf="
                      !withFinancialImpact &&
                        (item.key === 'maco_uplift' ||
                          item.key === 'volume_retained');
                      else showValue
                    "
                  >
                    -
                  </ng-container>
                  <ng-template #showValue>
                    {{ item.key ? getKeyValue(item) : "" }}
                    <span *ngIf="item.showPercentage">%</span>
                    <span *ngIf="item.key == 'maco_uplift'">
                      ({{
                        nParseFloat(
                          (getValue("maco_uplift") / getValue("total_maco")) *
                            100 || 0
                        )
                      }}%)
                    </span>
                    <span *ngIf="item.key == 'volume_retained'">
                      ({{
                        nParseFloat(
                          (getValue("volume_retained") /
                            getValue("total_volume")) *
                            100 || 0
                        )
                      }}%)
                    </span>
                  </ng-template>
                </p>
              </div>
            </div>
          </div>
          <p-tabView
            styleClass="zone-requests-tabs"
            (onChange)="onTabChange($event)"
            *ngIf="dataFrom === 'simulation'"
          >
            <p-tabPanel header="Country" *ngIf="clusterLevelDict['Country']">
              <app-pho-table
                [tableColumns]="analysisTableColumns"
                [tableData]="countryTableData"
                [skeletonLoader]="showTableLoader"
                [showPagination]="countryTableData.length > 5 ? true : false"
                [dataFrom]="'text-left'"
                [scrollFlag]="true"
                (emitTableSelection)="getSelectedRowItem($event, 'country')"
                [accessType]="accessType"
              ></app-pho-table>
            </p-tabPanel>
            <p-tabPanel header="Region" *ngIf="clusterLevelDict['Region']">
              <app-pho-table
                [tableColumns]="analysisTableColumns"
                [tableData]="regionTableData"
                [skeletonLoader]="showTableLoader"
                [showPagination]="regionTableData.length > 5 ? true : false"
                [scrollFlag]="true"
                [dataFrom]="'text-left'"
                (emitTableSelection)="getSelectedRowItem($event, 'region')"
              ></app-pho-table>
              <div class="flex mt-2">
                <app-sku-details-dropdown
                  (actionBtnCallback)="onSubLevelChange($event, 'region')"
                  [dropdownOptions]="regionClusterList"
                >
                </app-sku-details-dropdown>
                <div class="ml-auto flex items-center mr-4">
                  <div class="level-label mr-4">
                    Level 1 :
                    <span
                      [class]="skuDetails?.level1_recommendation.toLowerCase()"
                      >{{ skuDetails?.level1_recommendation }}</span
                    >
                  </div>
                  <div class="level-label">
                    Level 2 :
                    <span [class]="skuDetails?.model_output.toLowerCase()">
                      {{ skuDetails?.model_output }}</span
                    >
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="State" *ngIf="clusterLevelDict['State']">
              <app-pho-table
                [tableColumns]="analysisTableColumns"
                [tableData]="stateTableData"
                [skeletonLoader]="showTableLoader"
                [showPagination]="stateTableData.length > 5 ? true : false"
                [scrollFlag]="true"
                [dataFrom]="'text-left'"
                (emitTableSelection)="getSelectedRowItem($event, 'state')"
              ></app-pho-table>
              <div class="flex mt-2">
                <app-sku-details-dropdown
                  (actionBtnCallback)="onSubLevelChange($event, 'state')"
                  [dropdownOptions]="stateClusterList"
                >
                </app-sku-details-dropdown>
                <div class="ml-auto flex items-center mr-4">
                  <div class="level-label mr-4">
                    Level 1 :
                    <span
                      [class]="skuDetails?.level1_recommendation.toLowerCase()"
                      >{{ skuDetails?.level1_recommendation }}</span
                    >
                  </div>
                  <div class="level-label">
                    Level 2 :
                    <span [class]="skuDetails?.model_output.toLowerCase()">
                      {{ skuDetails?.model_output }}</span
                    >
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Channel" *ngIf="clusterLevelDict['Channel']">
              <app-pho-table
                [tableColumns]="analysisTableColumns"
                [tableData]="channelTableData"
                [skeletonLoader]="showTableLoader"
                [showPagination]="channelTableData.length > 5 ? true : false"
                [scrollFlag]="true"
                [dataFrom]="'text-left'"
                (emitTableSelection)="getSelectedRowItem($event, 'channel')"
              ></app-pho-table>
              <div class="flex mt-2">
                <app-sku-details-dropdown
                  (actionBtnCallback)="onSubLevelChange($event, 'channel')"
                  [dropdownOptions]="channelClusterList"
                >
                </app-sku-details-dropdown>
                <div class="ml-auto flex items-center mr-4">
                  <div class="level-label mr-4">
                    Level 1 :
                    <span
                      [class]="skuDetails?.level1_recommendation.toLowerCase()"
                      >{{ skuDetails?.level1_recommendation }}</span
                    >
                  </div>
                  <div class="level-label">
                    Level 2 :
                    <span [class]="skuDetails?.model_output.toLowerCase()">
                      {{ skuDetails?.model_output }}</span
                    >
                  </div>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
          <div class="mt-3 flex justify-between gap-3 pr-3">
            <div class="voting-card">
              <h3 class="head-h3">MACO Margin Trend</h3>
              <p-chart
                #macoSegmentChart
                height="300"
                type="line"
                [data]="macoLineChartData"
                [options]="macoLineChartOptions"
              ></p-chart>

              <div class="legend-item-out mt-2">
                <div
                  *ngFor="let item of legendMacoSegmentChart; let i = index"
                  class="legend-item"
                  (click)="
                    onLegendItemClick(
                      i,
                      'macoSegmentChart',
                      'legendMacoSegmentChart'
                    )
                  "
                >
                  <div
                    class="legend-color"
                    [style.background-color]="item.color"
                  ></div>
                  <div
                    class="legend-label"
                    [ngClass]="!item?.textHide ? 'overline' : 'no-underline'"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
            </div>
            <div class="voting-card">
              <h3 class="head-h3">Volume Trend</h3>
              <p-chart
                #revenueVolumeChart
                height="300"
                type="line"
                [data]="revenueLineChartData"
                [options]="revenueLineChartOptions"
              ></p-chart>
              <div class="legend-item-out mt-2">
                <div
                  *ngFor="let item of legendRevenueVolumeChart; let i = index"
                  class="legend-item"
                  (click)="
                    onLegendItemClick(
                      i,
                      'revenueVolumeChart',
                      'legendRevenueVolumeChart'
                    )
                  "
                >
                  <div
                    class="legend-color"
                    [style.background-color]="item.color"
                  ></div>
                  <div
                    class="legend-label"
                    [ngClass]="!item?.textHide ? 'overline' : 'no-underline'"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-3 flex justify-between gap-3"
            *ngIf="dataFrom == 'simulation'"
          >
            <div class="voting-card">
              <div class="validation-heading">AI PHO Validation</div>
              <div class="mt-4 mx-auto" *ngIf="skuDetails.validation">
                <div
                  class="flex justify-between validation-item"
                  *ngFor="
                    let validation of skuDetails?.validation[0] | keyvalue
                  "
                >
                  <div>
                    {{
                      validation?.key === "MACO Margin > Segment MACO Margin"
                        ? "MACO Margin > Country MACO Margin"
                        : validation?.key
                    }}
                  </div>
                  <div>
                    <app-svg-icon
                      *ngIf="
                        !skuDetails?.validation[0][getString(validation.key)]
                      "
                      padding="8px"
                      icon="cross"
                      color="#D14447"
                    >
                    </app-svg-icon>
                    <app-svg-icon
                      *ngIf="
                        skuDetails?.validation[0][getString(validation.key)]
                      "
                      padding="10px"
                      icon="tick-green"
                      color="#6EBC14"
                    >
                    </app-svg-icon>
                  </div>
                </div>
              </div>
              <div
                class="box h-[120px] flex justify-center items-center"
                *ngIf="!skuDetails?.validation[0]"
              >
                No Data found
              </div>
            </div>
            <div class="voting-card">
              <div class="validation-heading">Nesting Analysis</div>
              <div class="mt-4" *ngIf="nestingAnalysisTableData">
                <div class="flex justify-center">
                  <app-pho-table
                    [tableColumns]="nestingAnalysisTableColumns"
                    [tableData]="nestingAnalysisTableData"
                    [skeletonLoader]="showTableLoader"
                    [showPagination]="
                      nestingAnalysisTableData.length > 5 ? true : false
                    "
                  ></app-pho-table>
                </div>
              </div>
              <div
                class="box h-[120px] flex justify-center items-center"
                *ngIf="!nestingAnalysisTableData"
              >
                No Data found
              </div>
            </div>
          </div>
          <div
            class="mt-3 flex justify-between gap-3 abi-nonabi-block"
            *ngIf="withFinancialImpact && dataFrom !== 'simulation'"
          >
            <div class="voting-card">
              <div class="table-heading">Top 5 ABI Similar SKUs</div>
              <table>
                <thead>
                  <tr>
                    <th>SKU Name</th>
                    <th>Vol Absorbed %</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="skuDetails?.similar_abi_skus?.length > 0"
                  >
                    <tr *ngFor="let sku of skuDetails?.similar_abi_skus">
                      <td class="text-left">{{ sku?.sku_name }}</td>
                      <td class="text-center">
                        {{ nParseFloat(sku?.vol_absorbed * 100) }}%
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="skuDetails?.similar_abi_skus?.length == 0">
                    <td colspan="2">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="voting-card">
              <div class="table-heading">Top 5 Non ABI Similar SKUs</div>
              <table>
                <thead>
                  <tr>
                    <th>SKU Name</th>
                    <th>Vol Absorbed %</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="skuDetails?.similar_non_abi_skus?.length > 0"
                  >
                    <tr *ngFor="let sku of skuDetails?.similar_non_abi_skus">
                      <td class="text-left">{{ sku?.sku_name }}</td>
                      <td class="text-center">
                        {{ nParseFloat(sku?.vol_absorbed * 100) }}%
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="skuDetails?.similar_non_abi_skus?.length == 0">
                    <td colspan="2">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3 side-block" *ngIf="dataFrom !== 'simulation'">
        <div class="validation-block">
          <div>
            <div class="validation-heading">
              AI PHO Validation<span class="sku-age">
                ( {{ skuDetails?.age }} Months )</span
              >
            </div>
            <div class="mt-1">
              <div
                class="flex justify-between validation-item"
                *ngFor="let validation of skuDetails?.validation[0] | keyvalue"
              >
                <div class="validation-key">
                  {{
                    validation?.key === "MACO Margin > Segment MACO Margin"
                      ? "MACO Margin > Country MACO Margin"
                      : validation?.key
                  }}
                </div>
                <div>
                  <app-svg-icon
                    *ngIf="
                      !skuDetails?.validation[0][getString(validation?.key)]
                    "
                    padding="8px"
                    icon="cross"
                    color="#D14447"
                  >
                  </app-svg-icon>
                  <app-svg-icon
                    *ngIf="
                      skuDetails?.validation[0][getString(validation?.key)]
                    "
                    padding="10px"
                    icon="tick-green"
                    color="#6EBC14"
                  >
                  </app-svg-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4" *ngIf="withPreviousAnalysis">
          <div class="analysis-block">
            <div class="validation-heading flex justify-between">
              <span>Last Analysis </span>
              <span>
                <span class="sku-age"> Model Output</span>
                <span [ngClass]="getClass(modelOutput)">{{ modelOutput }}</span>
              </span>
            </div>

            <div class="flex flex-col gap-2 py-2">
              <div
                *ngFor="let item of items"
                class="flex flex-wrap items-center gap-2 my-2"
              >
                <span class="w-40 flex-shrink-0 text-xs metric-name">{{
                  item.name
                }}</span>
                <span
                  class="font-semibold text-sm break-words flex-1 pr-[-8px]"
                  >{{ item.value }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex justify-end pt-2 items-end"
      *ngIf="dataFrom == 'simulation'"
    >
      <app-keep-button
        btnSize="small-btn"
        class="mr-2"
        [btnDisable]="lockAssortment"
        [isRecommended]="overallLevelSKU.simulation == 'Keep'"
        (actionBtnCallback)="updateSimulation($event, 'Keep')"
      ></app-keep-button>
      <app-delist-button
        btnSize="small-btn"
        class="mr-2"
        [btnDisable]="lockAssortment"
        [isRecommended]="overallLevelSKU.simulation == 'Delist'"
        (actionBtnCallback)="updateSimulation($event, 'Delist')"
      ></app-delist-button>
      <app-consult-button
        btnSize="small-btn"
        class="mr-2"
        [btnDisable]="lockAssortment"
        [isRecommended]="overallLevelSKU.simulation == 'Consult'"
        (actionBtnCallback)="updateSimulation($event, 'Consult')"
      ></app-consult-button>
    </div>
  </ng-template>
</p-dialog>
